module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('ModuleBasketButton', {
    attrs: {
      "isBasketMode": !_vm.isModuleSaved
    },
    on: {
      "basket": _vm.addOrRemoveToBasket
    }
  }), _c('ListCardBadge', {
    attrs: {
      "badges": _vm.badges
    }
  }), _c('router-link', {
    staticClass: "card__main",
    attrs: {
      "to": _vm.linkParam
    }
  }, [_c('main', [(_vm.title) ? _c('h3', {
    staticClass: "card__title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), (_vm.competences) ? _c('p', {
    staticClass: "card__competence"
  }, [_c('span', [_vm._v("Компетенция:")]), _c('br'), _vm._v(_vm._s(_vm.competences))]) : _vm._e()]), (_vm.educationForm) ? _c('div', {
    staticClass: "card__type"
  }, [_vm._v(_vm._s(_vm.educationForm))]) : _vm._e()]), _c('div', {
    staticClass: "card__buttons"
  }, [_c('div', {
    staticClass: "card__cost"
  }, [_vm._v(_vm._s(_vm.costParam))]), _c('MoreButton', {
    on: {
      "more": _vm.moreHandler
    }
  }, [_vm._v("Подробнее")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e8087e9c","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/modules/card/ModuleCard.vue
// module id = 352425140e0300e83378
// module chunks = 0